export function hasUnsupportedControlChars(value) {
	if (!value) return false

	for (const char of String(value)) {
		const code = char.charCodeAt(0)
		if (code < 32 || code === 127) return true
	}

	return false
}

export function isValidPhone(value) {
	return !value || /^[0-9+\s]+$/.test(value)
}

export function isValidPersonName(value) {
	return !value || /^[\p{L}\s.'-]+$/u.test(value)
}

export function isValidBusinessName(value) {
	return !value || !/[<>[\]{}|^~`$%!?#§*=]/.test(value)
}

export function isValidStreetAddress(value) {
	return !value || /^[\p{L}\p{N}\s.,'‘’()/\-]+$/u.test(value)
}

export function isValidCity(value) {
	return !value || /^[\p{L}\s.'‘’()-]+$/u.test(value)
}

export function isValidZipCode(value) {
	return !value || /^[A-Za-z0-9\s-]+$/.test(value)
}

export function isValidAccountNumber(value) {
	return !value || /^[A-Za-z0-9\s\-/.]+$/.test(value)
}

export function isValidIban(value) {
	return !value || /^[A-Za-z0-9\s]+$/.test(value)
}

export function isValidBic(value) {
	return !value || /^[A-Za-z0-9]+$/.test(value)
}
